<!-- Ignore this part, it is only here to position drawer inside the example block -->
<div class="custom-portal"><ng-container #viewContainer /></div>

<div class="app-top-chrome">
  <app-notification-banner></app-notification-banner>

  <header *ngIf="!hideNavigation" tuiTheme="theme" tuiNavigationHeader class="main-header">
    <button appearance="flat" iconStart="@tui.menu" tuiIconButton type="button" class="mobile-menu-btn"
      aria-label="Open Navigation Menu" [attr.aria-expanded]="mobileNavOpen()" (click)="toggleMobileMenu()"></button>
    <div class="logo-align">
      <img src="assets/logo/parking_icon.png" alt="Parking Icon" height="32" [tuiSkeleton]="loadingParking()"
        class="border-radius">
      <img src="assets/logo/parking_logo.svg" alt="Parking Icon" height="16" [tuiSkeleton]="loadingParking()"
        class="border-radius">
    </div>


    <span tuiNavigationSegments [style.align-items]="'center'">
      <!-- Role Switcher Component - Only show for admin users -->
      <app-simple-role-switcher *ngIf="shouldShowRoleSwitcher()"></app-simple-role-switcher>

      <!-- Fallback role display if no role switcher - Only show for super admin and admin users -->
      <tui-chip *ngIf="isAdminOrSuperAdmin()" appearance="accent" size="xs"
        [style.border-radius]="'var(--tui-radius-s)'" [style.text-transform]="'capitalize'"
        [tuiSkeleton]="loadingParking()">
        {{ getRoleName() || 'Parking Admin'}}
      </tui-chip>


      <!-- Parking dropdown - Show for all users who have parking access -->
      <label tuiLabel *ngIf="hasParkingAccess() && !isSuperAdmin()" [tuiSkeleton]="loadingParking()"
        class="border-radius header-parking-label">
        <tui-textfield tuiChevron tuiTextfieldSize="s" [tuiTextfieldCleaner]="false" [stringify]="stringifyParking"
          [identityMatcher]="identityMatcher" [style.margin-inline-end]="'0px'">
          <input placeholder="Select Parking" tuiSelect [formControl]="parkingControl" />
          <tui-data-list-wrapper *tuiTextfieldDropdown new [items]="parkingList" [itemContent]="customParkingItem" />
          <ng-template #customParkingItem let-item>
            <span>{{ stringifyParking(item) }}</span>
          </ng-template>
        </tui-textfield>
      </label>

      <!-- Manual role toggle button for testing -->
      <!-- <button tuiButton size="xs" appearance="primary" (click)="toggleRole()" style="margin-left: 5px;"
      *ngIf="shouldShowRoleSwitcher()">
    </button> -->


      <!-- <button appearance="secondary-grayscale" tuiButton tuiChevron tuiDropdownOpen type="button" [tuiDropdown]="products"
      tuiClickOutside="open = false">
      <span [style.overflow]="'hidden'" [style.text-overflow]="'ellipsis'">
        Select Parking
      </span>
      <ng-template #products>
        <tui-data-list size="s">
          <button tuiOption type="button">
            Parking 1
            <tui-icon icon="@tui.check" [style.font-size.em]="1" [style.margin-left.rem]="0.5" />
          </button>
          <button tuiOption type="button">
            Parking 2
          </button>
        </tui-data-list>
      </ng-template>
    </button> -->
    </span>
    <!-- <hr /> -->

    <!-- <tui-textfield (pointerdown.capture.stop)="(0)">
    <input tuiSearchHotkey [formControl]="control" [tuiInputSearch]="search" [(tuiInputSearchOpen)]="open" />
    <ng-template #search>
      <tui-search-results [results]="results$ | async">
        <tui-search-history [popular]="popular" />
        <ng-template let-item>
          <a tuiCell [href]="item.href">
            <tui-avatar [src]="item.icon || '@tui.file'" />
            <span tuiTitle>
              {{ item.title }}
              <span tuiSubtitle>{{ item.subtitle }}</span>
            </span>
          </a>
        </ng-template>
      </tui-search-results>
    </ng-template>
  </tui-textfield> -->

    <hr />

    <div class="plan-details" *ngIf="shouldShowUpgradePlanButton()">
      <div class="plan-info" *ngIf="planName || planExpiryDate || isPlanCancelled || isPlanExpired">
        <tui-chip *ngIf="planName || isPlanCancelled || isPlanExpired"
          [appearance]="(isPlanExpired || isPlanCancelled) ? 'secondary' : 'accent'" size="xxs"
          [tuiSkeleton]="loadingParking()" class="border-radius">
          {{ isPlanExpired ? 'Expired' : (planName || (isPlanCancelled ? 'No Subscription' : '')) }}
        </tui-chip>
        <div class="expiry-date border-radius" *ngIf=" planExpiryDate" [tuiSkeleton]="loadingParking()">
          {{ (isPlanCancelled || isPlanExpired) ? 'Expired on:' : 'Expires on:' }} {{ formatExpiryDate(planExpiryDate)
          }}
        </div>
      </div>
      <button tuiButton size="s" appearance="primary" [routerLink]="getUpgradePlanRoute()"
        *ngIf="shouldShowUpgradeButton()" [tuiSkeleton]="loadingParking()">
        Upgrade
      </button>
    </div>

    <!-- Hidden PlanDetailsComponent for dialog -->
    <app-plan-details #planDetailsComponent style="display: none;"></app-plan-details>


    <button [appearance]="supportDrawerOpen() ? 'primary' : 'secondary-grayscale'" iconStart="@tui.headset"
      tuiIconButton type="button" [tuiSkeleton]="loadingParking()" (click)="toggleSupportDrawer()">Support</button>

    <!-- <app-language [tuiSkeleton]="loadingParking()" /> -->
    <button appearance="secondary-grayscale" iconStart="@tui.bell" tuiIconButton type="button"
      [tuiDropdown]="notificationsContent" [(tuiDropdownOpen)]="notificationsOpen" tuiDropdownAlign="right"
      [tuiDropdownOffset]="8" [tuiSkeleton]="loadingParking()">
      Notifications
      <tui-badge-notification *ngIf="unreadCount() > 0" [tuiSkeleton]="loadingParking()">
        {{ unreadCount() }}
      </tui-badge-notification>
    </button>

    <ng-template #notificationsContent>
      <div class="notifications-card" tuiAppearance="floating" tuiCardLarge>
        <header class="card-header">
          <div class="title-row">
            <h4 tuiTitle [tuiSkeleton]="loadingParking()">Notifications</h4>
            <button *ngIf="unreadCount() > 0" tuiButton type="button" size="s" appearance="secondary-grayscale"
              (click)="markAllAsRead(); $event.stopPropagation()" [tuiSkeleton]="loadingParking()">
              Clear all
            </button>
          </div>
          <!--
        <tui-segmented size="s" class="filter-tabs" [activeItemIndex]="activeNotificationTab()"
          (activeItemIndexChange)="activeNotificationTab.set($event)">
          <button type="button">All</button>
          <button type="button">Unread ({{ unreadCount() }})</button>
        </tui-segmented>
        -->
        </header>

        <div class="scroll-list coming-soon-container">
          <div class="coming-soon-content">
            <div class="icon-wrapper">
              <tui-icon icon="@tui.sparkles" class="coming-soon-icon" [tuiSkeleton]="loadingParking()"></tui-icon>
            </div>
            <h3 [tuiSkeleton]="loadingParking()">Coming Soon</h3>
            <p [tuiSkeleton]="loadingParking()">We're polishing your personalized notification experience. Stay tuned!
            </p>
          </div>
        </div>

        <!-- 
      <div class="scroll-list-original">
        <div *ngIf="filteredNotifications().length === 0" class="empty-state">
          <tui-icon icon="@tui.bell-off" size="l" class="empty-icon"></tui-icon>
          <p>No new updates here</p>
        </div>

        <button *ngFor="let notification of filteredNotifications()" type="button" class="list-item"
          [class.unread-item]="!notification.isRead" (click)="markNotificationAsRead(notification.id)">
          <div class="item-content">
            <tui-avatar [style.background]="notification.color" [style.color]="'white'" size="s" class="item-avatar">
              <tui-icon [icon]="notification.icon"></tui-icon>
            </tui-avatar>
            <div class="text-group">
              <div class="meta-row">
                <span class="category-label">{{ notification.label }}</span>
                <span class="time-ago">{{ notification.time }}</span>
              </div>
              <div class="subject">{{ notification.title }}</div>
              <div class="message">{{ notification.description }}</div>
            </div>
            <div *ngIf="!notification.isRead" class="status-indicator"></div>
          </div>
        </button>
      </div>
      -->

        <!-- <footer class="card-footer">
        <button tuiButton type="button" appearance="flat" class="footer-btn"
          [routerLink]="getDynamicRouterLink('/notifications')" (click)="notificationsOpen.set(false)"
          (mouseenter)="onNavHover('/notifications')">
          Notification Center
          <tui-icon icon="@tui.arrow-right" class="footer-arrow"></tui-icon>
        </button>
      </footer> -->
      </div>
    </ng-template>

    <div class="avatart-icon">
      <tui-avatar size="s" [src]="getUserAvatarSrc() | tuiFallbackSrc: getUserInitials() | async"
        (click)="isOpen = !isOpen" class="img" [tuiSkeleton]="loadingParking()" />

      <div class="profile-drop" tuiAppearance="floating" tuiCardLarge [ngClass]="{ hidden: !isOpen }"
        tuiClickOutside="isOpen = false">
        <section class="actions">
          <div tuiCell="l">
            <tui-avatar [src]="getUserAvatarSrc() | tuiFallbackSrc: getUserInitials() | async" size="l"
              [tuiSkeleton]="loadingParking()" />
            <h2 tuiTitle [tuiSkeleton]="loadingParking()">
              <b>{{ getUserDisplayName() }}</b>
              <div tuiSubtitle [style.color]="'var(--tui-text-secondary)'" [tuiSkeleton]="loadingParking()">
                <div>
                  <div [tuiSkeleton]="loadingParking()">{{ getUserContactDisplay() }}</div>
                  <div style="margin-top: 5px; color: var(--tui-text-primary);" [tuiSkeleton]="loadingParking()">{{
                    getRoleNameFromAPI() }}</div>
                </div>
              </div>
            </h2>
          </div>
        </section>
        <section>
          <tui-data-list tuiDataListDropdownManager size="m">
            <button tuiOption type="button" style="cursor: auto; background-color: transparent;">
              <div>
                <span [tuiSkeleton]="loadingParking()">Account managed by {{ (apiService.userSignal()?.company ||
                  organizationName) || 'N/A' }}</span>
              </div>
            </button>
            <!-- them toggle -->
            <div class="flex-toggle">
              <div class="col">
                <button tuiOption type="button" class="none-cursor"
                  style="cursor: auto; background-color: transparent;">
                  <div>
                    Theme: {{ isDarkMode ? 'Dark' : 'Light' }}
                  </div>
                </button>
              </div>
              <div class="col">
                <tui-segmented [activeItemIndex]="activeThemeIndex" [tuiSkeleton]="loadingParking()">
                  <button type="button" title="light" (click)="setTheme(false)"
                    [ngClass]="{ 'tui-segmented_active': !isDarkMode }" [value]="'light'">
                    <tui-icon icon="@tui.sun" />
                  </button>
                  <button type="button" title="dark" (click)="setTheme(true)"
                    [ngClass]="{ 'tui-segmented_active': isDarkMode }" [value]="'dark'">
                    <tui-icon icon="@tui.moon" />
                  </button>
                </tui-segmented>
              </div>
            </div>
            <button tuiOption type="button" (click)="exitVendorViewMode()" *ngIf="shouldShowManageAccountButton()"
              [tuiSkeleton]="loadingParking()">Manage
              this account</button>
            <a tuiOption [routerLink]="getDynamicRouterLink('/profile')" [tuiSkeleton]="loadingParking()"
              (mouseenter)="onNavHover('/profile')">My Profile</a>
            <button tuiOption type="button" (click)="logout()" [tuiSkeleton]="loadingParking()">Logout</button>
          </tui-data-list>
        </section>
      </div>
    </div>
  </header>
</div>

<div class="app-layout-shell" [class.support-open]="supportDrawerOpen()"
  [class.support-wide]="supportDrawerOpen() && supportDrawerExpanded()" [class.navigation-hidden]="hideNavigation">
  <!-- Main Application Column (Sidebar + Content Viewport) -->
  <div class="app-main-panel">
    <div class="navigation-shell" [class.mobile-nav-open]="mobileNavOpen()" [style.display]="'flex'">
      <div class="mobile-nav-backdrop" *ngIf="mobileNavOpen()" (click)="closeMobileNav()"></div>
      <aside *ngIf="!hideNavigation" [style.height]="asideHeight()" [tuiNavigationAside]="expanded()" tuiTheme="theme"
        class="invert-color" (click)="onAsideNavigate($event)"
        [attr.inert]="isPhoneLayout() && !mobileNavOpen() ? '' : null">
        <div class="nav-steps" [class.show-settings]="isPhoneLayout() && mobileSettingsStep()">
          <div class="nav-step" [attr.inert]="isPhoneLayout() && mobileSettingsStep() ? '' : null">
            <header>
              <button tuiAsideItem type="button" class="none-cursor" [style.padding]="'5px'"
                [title]="!expanded() ? (apiService.userSignal()?.company || organizationName || '') : ''"
                [tuiSkeleton]="loadingParking()">
                <span tuiFade *ngIf="expanded(); else initials">{{ apiService.userSignal()?.company || organizationName ||
                  ''
                  }}</span>
                <ng-template #initials>{{ getOrganizationInitials() }}</ng-template>
              </button>
            </header>

            <ng-container *ngIf="navigationItems && navigationItems.length > 0">
              <ng-container *ngFor="let item of navigationItems">
                <a *ngIf="!item.children && hasAccess(item) && item.route !== '/settings' && !item.route?.includes('reservation') && !item.label?.toLowerCase()?.includes('reservation')"
                  tuiAsideItem [ngClass]="{ 'active_route': isRouteActive(item.route) }"
                  [routerLink]="getDynamicRouterLink(item.route)" style="cursor: pointer;" class="border-radius"
                  (mouseenter)="onNavHover(item.route)">
                  <img [src]="getRoleSpecificIcon(item)" alt="" [tuiSkeleton]="loadingParking()" class="border-radius">
                  <span [tuiSkeleton]="loadingParking()" class="border-radius">{{ getRoleSpecificLabel(item) }}</span>
                </a>

                <ng-container
                  *ngIf="item.children && hasAccess(item) && !item.route?.includes('reservation') && !item.label?.toLowerCase()?.includes('reservation')">
                  <app-input-heading [heading]="getRoleSpecificLabel(item)" style="font-size: 11px;"
                    [tuiSkeleton]="loadingParking()" />
                  <ng-container *ngFor="let child of item.children">
                    <a tuiAsideItem *ngIf="hasAccess(child)" [ngClass]="{ 'active_route': isRouteActive(child.route) }"
                      [routerLink]="getDynamicRouterLink(child.route)" class="btn-margn" style="cursor: pointer;"
                      (mouseenter)="onNavHover(child.route)">
                      <img [src]="getRoleSpecificIcon(child)" alt="" [tuiSkeleton]="loadingParking()" class="border-radius">
                      <span [tuiSkeleton]="loadingParking()" class="border-radius">{{ getRoleSpecificLabel(child) }}</span>
                    </a>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>

            <hr>
            <a *ngIf="!isPhoneLayout()" tuiAsideItem [ngClass]="{ 'active_route': isRouteActive('/settings') }"
              [routerLink]="getDynamicRouterLink('/settings')" (click)="expanded.set(false)" style="cursor: pointer;"
              (mouseenter)="onNavHover('/settings')">
              <img src="assets/images/icons/modules/Settings.svg" alt="settings" [tuiSkeleton]="loadingParking()"
                class="border-radius">
              <span [tuiSkeleton]="loadingParking()" class="border-radius">Settings</span>
            </a>
            <button *ngIf="isPhoneLayout()" tuiAsideItem type="button" class="settings-step-link"
              (click)="openSettingsStep($event)">
              <img src="assets/images/icons/modules/Settings.svg" alt="" [tuiSkeleton]="loadingParking()"
                class="border-radius">
              <span [tuiSkeleton]="loadingParking()" class="border-radius">Settings</span>
              <tui-icon icon="@tui.chevron-right" class="step-chevron" />
            </button>
          </div>

          <div class="nav-step" *ngIf="isPhoneLayout()" [attr.inert]="mobileSettingsStep() ? null : ''">
            <header>
              <button tuiAsideItem type="button" class="settings-step-back" (click)="backToMainNav($event)">
                <tui-icon icon="@tui.chevron-left" />
                <span>Settings</span>
              </button>
            </header>
            <ng-container *ngFor="let item of settingsNavigationItems">
              <a *ngIf="item && !item.children" tuiAsideItem
                [ngClass]="{ 'active_route': isRouteActive(item.route) }"
                [routerLink]="getDynamicRouterLink(item.route)" style="cursor: pointer;"
                (mouseenter)="onNavHover(item.route)">
                <img [src]="getSettingsRoleSpecificIcon(item)" [alt]="item.label || ''" [tuiSkeleton]="loadingParking()"
                  class="border-radius">
                <span [tuiSkeleton]="loadingParking()" class="border-radius">{{ getSettingsRoleSpecificLabel(item) }}</span>
              </a>
              <ng-container *ngIf="item?.children?.length">
                <app-input-heading [heading]="getSettingsRoleSpecificLabel(item)" style="font-size: 11px;"
                  [tuiSkeleton]="loadingParking()" />
                <a *ngFor="let child of item.children" tuiAsideItem
                  [ngClass]="{ 'active_route': isRouteActive(child.route) }"
                  [routerLink]="getDynamicRouterLink(child.route)" style="cursor: pointer;"
                  (mouseenter)="onNavHover(child.route)">
                  <img [src]="getSettingsRoleSpecificIcon(child)" [alt]="child.label || ''"
                    [tuiSkeleton]="loadingParking()" class="border-radius">
                  <span [tuiSkeleton]="loadingParking()" class="border-radius">{{ getSettingsRoleSpecificLabel(child) }}</span>
                </a>
              </ng-container>
            </ng-container>
          </div>
        </div>

        <footer *ngIf="!isPhoneLayout() || !mobileSettingsStep()">
          <button tuiAsideItem type="button" [iconStart]="expanded() ? '@tui.chevron-left' : '@tui.chevron-right'"
            (click)="handleToggle()" [tuiSkeleton]="loadingParking()">
            {{ expanded() ? 'Collapse' : 'Expand' }}
          </button>
        </footer>
      </aside>

      <main tuiNavigationMain class="custom-main"
        [style]="router.url.startsWith('/settings') ? 'border: none; flex: none!important;' : 'border: none;'">
        <ng-content></ng-content>
      </main>
    </div>
  </div>

  <!-- Collapsible Support Slider Panel (Docked right, full height, smooth slide-in/out) -->
  <aside class="app-support-slider-panel" [class.open]="supportDrawerOpen()"
    [class.wide]="supportDrawerOpen() && supportDrawerExpanded()">
    <app-support-drawer [open]="supportDrawerOpen" [isExpanded]="supportDrawerExpanded()"
      (isExpandedChange)="handleDrawerExpandedChange($event)">
    </app-support-drawer>
  </aside>
</div>